import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ng2-tooltip-directive';
import { DataTableModule } from 'ng-angular8-datatable';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { AppCommonModule } from '@root/common/app-common.module';

import { CatalogueComponent } from './catalogue.component';
import { CatalogueExcelComponent } from './catalogue-excel/catalogue-excel.component';
import { FormsComponent } from './forms/forms.component';
import { UserDataComponent } from './user-data/user-data.component';

import { CatalogueImagesComponent } from './catalogue-images/catalogue-images.component';
import { ConfirmComponent } from './shared/confirm/confirm.component';
import { BannerListComponent } from './catalogue-images/banner-list/banner-list.component';
import { FundManagerImagesComponent } from './catalogue-images/fund-manager-images/fund-manager-images.component';
import { KeyFeaturesComponent } from './catalogue-images/key-features/key-features.component';
import { CatalogueVideosComponent } from './catalogue-videos/catalogue-videos.component';
import { InvestorVideoComponent } from './catalogue-videos/investor-video/investor-video.component';
import { ProductVideoComponent } from './catalogue-videos/product-video/product-video.component';
import { SectionsComponent } from './sections/sections.component';
import { AddSectionComponent } from './sections/add-section/add-section.component';
import { AddSubSectionComponent } from './sections/add-sub-section/add-sub-section.component';
import { FormsDownloadComponent } from './forms/forms-download/forms-download.component';
import { FormsSebiComponent } from './forms/forms-sebi/forms-sebi.component';
import { FormsUpdatesComponent } from './forms/forms-updates/forms-updates.component';
import { FormsCollateralsComponent } from './forms/forms-collaterals/forms-collaterals.component';
import { FormsPdfComponent } from './forms/forms-pdf/forms-pdf.component';
import { FormsDisclosureComponent } from './forms/forms-disclosure/forms-disclosure.component';
import { CatalogueVideoFormComponent } from './catalogue-videos/catalogue-video-form/catalogue-video-form.component';
import { CatalogueExcelListComponent } from './catalogue-excel/catalogue-excel-list/catalogue-excel-list.component';
import { CatalogueArticlesComponent } from './catalogue-articles/catalogue-articles.component';
import { CatalogueArticlesFormComponent } from './catalogue-articles/catalogue-articles-form/catalogue-articles-form.component';
import { CatalogueArticlesListComponent } from './catalogue-articles/catalogue-articles-list/catalogue-articles-list.component';
import { CatalougeCareersComponent } from './catalouge-careers/catalouge-careers.component';
import { CreateJobComponent } from './catalouge-careers/create-job/create-job.component';
import { ListJobComponent } from './catalouge-careers/list-job/list-job.component';
import { CatalogInvestorFormsComponent } from './forms/catalog-investor-forms/catalog-investor-forms.component';
import { FormsSchemeDocumentsComponent } from './forms/forms-scheme-documents/forms-scheme-documents.component';
import { CatalogueNavDividendsComponent } from './catalogue-nav-dividends/catalogue-nav-dividends.component';
import { CatalogNavDividentListComponent } from './catalogue-nav-dividends/catalog-nav-divident-list/catalog-nav-divident-list.component';
import { CatalogInvestorProcessComponent } from './forms/catalog-investor-process/catalog-investor-process.component';
import { CatalogueCareerConfigComponent } from './catalogue-career-config/catalogue-career-config.component';
import { InvestmentApproachComponent } from './catalogue-images/investment-approach/investment-approach.component';
import { CatalogThumbnailComponent } from './catalog-thumbnail/catalog-thumbnail.component';
import { ListThumbnailComponent } from './catalog-thumbnail/list-thumbnail/list-thumbnail.component';
import { UplaodThumbnailComponent } from './catalog-thumbnail/uplaod-thumbnail/uplaod-thumbnail.component';
import { CatalogueDigitalFactsheetComponent } from './catalogue-digital-factsheet/catalogue-digital-factsheet.component';
import { CatalogDigitalFactsheetListComponent } from './catalogue-digital-factsheet/catalog-digital-factsheet-list/catalog-digital-factsheet-list.component';
import { InvestorAwarenessProgramFormsComponent } from './forms/investor-awareness-program-forms/investor-awareness-program-forms.component';
import { CatalougeOurTeamComponent } from './catalouge-our-team/catalouge-our-team.component';
import { CatalougeAddTeamMemberComponent } from './catalouge-our-team/catalouge-add-team-member/catalouge-add-team-member.component';
import { CatalougeListTeamMembersComponent } from './catalouge-our-team/catalouge-list-team-members/catalouge-list-team-members.component';
import { ConfirmOrderComponent } from './shared/confirm-order/confirm-order.component';
import { CatalogueIapPageComponent } from './catalogue-iap-page/catalogue-iap-page.component';
import { CatalougeDisplayIAPContentComponent } from './catalogue-iap-page/catalouge-display-iap-content/catalouge-display-iap-content.component';
import { CatalougeAddIAPContentComponent } from './catalogue-iap-page/catalouge-add-iap-content/catalouge-add-iap-content.component';

@NgModule({
  declarations: [
    CatalogueExcelComponent,
    FormsComponent,
    UserDataComponent,
    CatalogueComponent,
    CatalogueImagesComponent,
    ConfirmComponent,
    BannerListComponent,
    FundManagerImagesComponent,
    KeyFeaturesComponent,
    CatalogueVideosComponent,
    InvestorVideoComponent,
    ProductVideoComponent,
    SectionsComponent,
    AddSectionComponent,
    AddSubSectionComponent,
    FormsDownloadComponent,
    FormsSebiComponent,
    FormsUpdatesComponent,
    FormsCollateralsComponent,
    FormsPdfComponent,
    FormsDisclosureComponent,
    CatalogueVideoFormComponent,
    CatalogueExcelListComponent,
    CatalogueArticlesComponent,
    CatalogueArticlesFormComponent,
    CatalogueArticlesListComponent,
    CatalougeCareersComponent,
    CreateJobComponent,
    ListJobComponent,
    FormsSchemeDocumentsComponent,
    CatalogueNavDividendsComponent,
    CatalogueDigitalFactsheetComponent,
    CatalogNavDividentListComponent,
    CatalogDigitalFactsheetListComponent,
    CatalogInvestorFormsComponent,
    InvestorAwarenessProgramFormsComponent,
    CatalogInvestorProcessComponent,
    CatalogueCareerConfigComponent,
    InvestmentApproachComponent,
    CatalogThumbnailComponent,
    ListThumbnailComponent,
    UplaodThumbnailComponent,
    CatalougeOurTeamComponent,
    CatalougeAddTeamMemberComponent,
    CatalougeListTeamMembersComponent,
    ConfirmOrderComponent,
    CatalogueIapPageComponent,
    CatalougeAddIAPContentComponent,
    CatalougeDisplayIAPContentComponent,
  ],
  imports: [
    CommonModule,
    TooltipModule,
    DataTableModule,
    FormsModule,
    AngularEditorModule,
    AppCommonModule,
  ],
  entryComponents: [ConfirmComponent, ConfirmOrderComponent],
})
export class CatalogueModule {}
